import { useMemo } from "react";
export const createNestDataFn = (pathKeys) => {
    return (data) => {
        return nestData(data, pathKeys);
    };
};
export const createNestDataHook = (pathKeys) => {
    return (data) => {
        return useNestedData(data, pathKeys);
    };
};
export const nestData = (data, pathKeys) => {
    if (pathKeys.length < 1)
        return data;
    const obj = {};
    let lastObj = obj;
    for (let i = 0; i < pathKeys.length; i++) {
        const key = pathKeys[i];
        lastObj[key] = {};
        if (i === pathKeys.length - 1) {
            lastObj[key] = data;
        }
        lastObj = lastObj[key];
    }
    return obj;
};
export const useNestedData = (data, pathKeys) => {
    return useMemo(() => nestData(data, pathKeys), [data, ...pathKeys]);
};
export function createDeepMergeFn({ mergeStrategy, decisionFn, }) {
    return function merge(object1, object2, path) {
        const obj1 = { ...object1 };
        for (const p in object2) {
            const propPath = (path ? path + "." : "") + p;
            if (!object2.hasOwnProperty(p))
                continue;
            if (object2[p] === obj1[p])
                continue;
            if (!obj1.hasOwnProperty(p)) {
                if (object2[p] !== undefined) {
                    obj1[p] = object2[p];
                }
                continue;
            }
            if (decisionFn) {
                const { skip } = decisionFn(propPath, object1, object2);
                if (skip)
                    continue;
            }
            if (object2[p].constructor === Object) {
                obj1[p] = merge(obj1[p], object2[p], propPath);
            }
            else {
                if (mergeStrategy === "overrideLeftToRight") {
                    if (!obj1.hasOwnProperty(p)) {
                        obj1[p] = object2[p];
                    }
                }
                else if (mergeStrategy === "overrideRightToLeft") {
                    obj1[p] = object2[p];
                }
            }
            if (obj1[p] === undefined)
                delete obj1[p];
        }
        return obj1;
    };
}
export function useMemoizedProps(props, flag) {
    const keys = Object.keys(props).sort();
    const deps = [];
    for (let i = 0; i < keys.length; ++i) {
        const key = keys[i];
        if (flag === "skipChildren" && key === "children")
            continue;
        deps.push(key, props[key]);
    }
    return useMemo(() => {
        const { children, ...rest } = props;
        return rest;
    }, deps);
}
